export default __webpack_public_path__ + "/assets/complesso-placeholder.jpg";